import Container from './Container'
import { ContainerType } from './ContainerType'
import { playerDims } from '../utils'

export default class DockedBottomRightContainer extends Container {
  constructor () {
    super(ContainerType.DOCKED_BR, false)
  }

  style (bid, slot, media) {
    const dims = playerDims(media, bid)

    const container = slot.container()
    container.style.position = 'fixed'
    container.style.bottom = '10px'
    if (!slot.node().style.width || !slot.node().style.height) {
      container.style.top = 'calc(100% - ' + (dims[1] + 10) + 'px)'
    }
    container.style.right = '10px'

    /* required to position buttons properly */
    slot.node().style.position = 'relative'
  }
}
